import * as ɵngcc0 from '@angular/core';
var LayoutService_1;
import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { dataApi } from '@sitecore-jss/sitecore-jss';
import { from as fromPromise, throwError as observableThrow } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LayoutServiceError } from './layout-service-error';
const { fetchRouteData, fetchPlaceholderData } = dataApi;
let LayoutService = LayoutService_1 = class LayoutService {
    static getLayoutServiceError(error) {
        const layoutServiceError = new LayoutServiceError();
        const response = error.response;
        if (response) {
            layoutServiceError.status = response.status;
            layoutServiceError.statusText = response.statusText;
            layoutServiceError.data = response.data;
        }
        return observableThrow(layoutServiceError);
    }
    getRouteData(route, options) {
        return fromPromise(fetchRouteData(route, options))
            .pipe(catchError(LayoutService_1.getLayoutServiceError));
    }
    getPlaceholderData(route, placeholderName, options) {
        return fromPromise(fetchPlaceholderData(placeholderName, route, options))
            .pipe(catchError(LayoutService_1.getLayoutServiceError));
    }
};
LayoutService.ɵfac = function LayoutService_Factory(t) { return new (t || LayoutService)(); };
LayoutService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LayoutService, factory: function (t) { return LayoutService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LayoutService, [{
        type: Injectable
    }], null, null); })();
export { LayoutService };
